import { Box, type SxProps, type Theme } from '@mui/material';

const FlexBox = (props: { children: React.ReactNode; style?: SxProps<Theme> }) => {
  const sx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
    ...props.style
  };

  return <Box sx={sx}>{props.children}</Box>;
};

export default FlexBox;
